import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { memo } from 'react';
import { CertificateANPR } from 'front-office/view-models/certificate/certificate-form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { HttpResponseList } from 'shell/models/http-response';
import { CertificateTypeANPRList } from 'shell/models/certificate-type';
import { isBlockingCheckbox } from 'front-office/constants/blocked-checkbox';
import { Operation } from 'shell/view-models/operation';
import { DocumentType } from 'front-office/constants/document-type';

interface AireCheckboxesProps {
  values?: CertificateANPR;
  onChange: (identifier: CertificateTypeANPRList) => void;
}

const AireCheckboxesComponent = ({ values, onChange }: AireCheckboxesProps): React.ReactElement => {
  const [typeCertificateCheckbox] = useHttpFetch<
    HttpResponseList<CertificateTypeANPRList>,
    Array<CertificateTypeANPRList>
  >(`${__CERTIFICATION_API_URL__}/certificazione/tipi-documento`, {
    onBootstrap: true,
    initialData: [],
    options: {
      params: {},
      paramsSerializer: () =>
        `filters=tipoDocumento:${DocumentType.Anpr}:${Operation.EQUALS}&filters=flagDocumentoInUso:1:${Operation.EQUALS}&filters=flagIscrittiAire:1`,
    },
    transformer: (response) => {
      return response.data.payload?.list?.filter(
        (element) => element.key.codiceDocumento !== DocumentType.Operazione
      ) as Array<CertificateTypeANPRList>;
    },
  });

  const checkboxList = (typeCertificateCheckbox.data as Array<CertificateTypeANPRList>) || [];

  return (
    <Grid container spacing={2}>
      {checkboxList.map((element) => {
        const isSelected = !!values?.find(
          (identifierSelected) =>
            identifierSelected.key.codiceDocumento === element.key.codiceDocumento
        );

        //TODO isHistory for disabled checkbox
        const isDisabled = !!values?.find((identifier) => {
          if (
            isBlockingCheckbox.includes(identifier.key.codiceDocumento) &&
            isBlockingCheckbox.includes(element.key.codiceDocumento)
          ) {
            return false;
          }

          if (
            !isBlockingCheckbox.includes(identifier.key.codiceDocumento) &&
            !isBlockingCheckbox.includes(element.key.codiceDocumento)
          ) {
            return false;
          }

          if (
            !isBlockingCheckbox.includes(identifier.key.codiceDocumento) &&
            isBlockingCheckbox.includes(element.key.codiceDocumento)
          ) {
            return false;
          }

          if (
            isBlockingCheckbox.includes(identifier.key.codiceDocumento) &&
            !isBlockingCheckbox.includes(element.key.codiceDocumento)
          ) {
            return true;
          }

          return false;
        });

        return (
          <Grid item xs={12} md={4} key={element.key.codiceDocumento}>
            <FormControlLabel
              control={
                <Checkbox
                  id={element.key.codiceDocumento}
                  checked={isSelected || false}
                  onChange={() => onChange(element)}
                  disabled={isDisabled}
                  inputProps={{ 'aria-label': element.descrizioneTipoDocumento }}
                />
              }
              label={element.descrizioneTipoDocumento}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

AireCheckboxesComponent.displayName = 'Aire checkboxes component';

const AireCheckboxes = memo(AireCheckboxesComponent);

export default AireCheckboxes;
